import React from "react";
import visionPhoto from "../../images/visionPhoto.jpeg";
import "./MissionVision.css";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";

const MissionVision = () => (
  <PageLayout>
    
    {/* Your reusable PageHero handles the text now */}
    <PageHero 
      title="Mission & Vision" 
      eyebrow="Who We Are" 
      subtitle="Discover what drives us forward and how we define a kinder world." 
      light 
    />

    {/* The 3D Carousel Section */}
    <section className="ku-section bg-ku-cream relative py-12 overflow-hidden flex justify-center items-center">
      <div className="ku-container mx-auto px-4 flex justify-center items-center min-h-[420px]">
        
        {/* 3D Stage Container */}
        <div className="carousel-stage w-full">
          
          {/* Spinning Wrapper */}
          <div className="carousel-spinner">
            
            {/* Card 1: Our Mission */}
            <div className="carousel-card card-1 bg-white rounded-[1.5rem] p-6 border-2 border-gray-100 shadow-xl text-center">
              <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight text-ku-violet uppercase mb-4">
                OUR MISSION
              </h3>
              <p className="font-body text-gray-600 leading-relaxed text-sm md:text-base">
                To transform mindsets to more sharing of time, resources, skills, knowledge and money. To celebrate the up standers in society.
              </p>
            </div>

            {/* Card 2: Definition of Kindness */}
            <div className="carousel-card card-2 bg-white rounded-[1.5rem] p-6 border-2 border-gray-100 shadow-xl text-center">
              <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight text-ku-violet uppercase mb-4">
                OUR DEFINITION OF KINDNESS
              </h3>
              <p className="font-body text-gray-600 leading-relaxed text-sm md:text-base">
                Balancing self-interest with the Common Good.
              </p>
            </div>

            {/* Card 3: Our Vision */}
            <div className="carousel-card card-3 bg-white rounded-[1.5rem] overflow-hidden border-2 border-gray-100 shadow-xl flex flex-col text-center">
              <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight text-ku-violet uppercase pt-6 pb-3">
                OUR VISION
              </h3>
              <div className="px-4 pb-4 flex-grow flex items-center justify-center h-40">
                <img
                  className="w-full h-full object-contain rounded-xl"
                  src={visionPhoto}
                  alt="Our vision"
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
    
  </PageLayout>
);

export default MissionVision;